import React, { Component } from 'react'
import { Form, Table, Tabs, Tab, Alert } from 'react-bootstrap';
import config from '../../config';

export class searchItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
            busqueda: "",
            key:"ref"
        }
    }

    consultar_unidades= (currentData, unidad, callback)=>{
        const currentCompany = sessionStorage.getItem('company');
        const idLista = (this.props.idLista || '0');
        const idItem = currentData.ID_ITEMS;
        const { clean } = this.props;

        const datasend = {
            method: 'POST',
            body: JSON.stringify({
                idItem,
                idLista,
                unidad
            }),
            headers: {
                'Content-Type': 'application/json',
                'empresa': currentCompany
            }
        };
        fetch(config.servBackEnd + '/items/unitpricebyitem/', datasend)
            .then(response => response.json())
            .then(data => {
                if (data.ok) {
                    const unidades = data.data[0];
                    currentData.LISTA_UNIDADES = unidades;
                    if (clean) this.setState({ busqueda: "" })
                    callback(currentData);
                } else {
                    //console.log(data);
                }
            })
    }

    localeventbarcode = ({ target }) => {
        const { value } = target;
        const { data_barcode } = this.props;
        const { event_barcode } = this.props;
        let cont = 0;
        let currentItem = [];
        let unit = "0";
        data_barcode.forEach(element => {
            if (element.CODIGO_BARRA === value) {
                cont = 1;
                currentItem = element;
                unit = element.UNIDAD_MEDIDA_BARCODE;
            }
        });
        if (cont === 1) {
            this.consultar_unidades(currentItem, unit ,event_barcode)
            this.setState({ busqueda: "" });
        } else {
            this.setState({ busqueda: value });
        }
    }

    localevent = (currentData) => {
        const { event } = this.props;
        const unit="0";
        this.consultar_unidades(currentData, unit , event);
    }

    setKey=(k)=>{
        this.setState({
            key: k,
            busqueda:""
        })
    }

    render() {
        const { data } = this.props;
        const { busqueda } = this.state;
        const localevent = this.localevent;
        const control = Number.isInteger(parseInt(busqueda, 10));
        return (
            <Tabs
            id="controlled-tab-example"
            activeKey={this.state.key}
            onSelect={(k) => this.setKey(k)}
            transition={false}>
                <Tab eventKey="ref" title="Items">
                    <div className="mt-3">
                        <div>
                            <Form.Label>Adicionar Item</Form.Label>
                            <Form.Control autoComplete="off" className="mb-2 mr-sm-2" id="busquedaItem" placeholder="Busqueda por Codigo o Nombre" onChange={(e) => this.setState({ busqueda: e.target.value })} value={busqueda} />
                        </div>
                        {(busqueda.length > 2 || control) &&
                            <div className="scrollTable">
                                <Table striped bordered hover size="sm">
                                    <thead>
                                        <tr>
                                            <th>Ref</th>
                                            <th>Descripcion</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.map((currentData, index) => {
                                            if (currentData.REFERENCIA_ITEM.toLowerCase().search(busqueda.toLowerCase()) > -1
                                                || currentData.DESCRIPCION_ITEM.toLowerCase().search(busqueda.toLowerCase()) > -1
                                                || currentData.CODIGO_ITEM.toLowerCase().search(busqueda.toLowerCase()) > -1) {
                                                return <tr key={index + "d0"} onClick={() => localevent(currentData)}>
                                                    <td key={index + "d1"}>{currentData.REFERENCIA_ITEM}</td>
                                                    <td key={index + "d2"}>{currentData.DESCRIPCION_ITEM}</td>
                                                </tr>
                                            } else {
                                                return null;
                                            }
                                        })}
                                    </tbody>
                                </Table>

                            </div>
                        }
                        {(busqueda.length <= 2 && !control) &&
                            <Alert variant="danger" >Ingrese al menos tres carateres</Alert>
                        }
                    </div>
                </Tab>
                <Tab eventKey="codebar" title="Codigo Barra">
                    <div className="mt-3">
                        <div>
                            <Form.Label>Adicionar Item</Form.Label>
                            <Form.Control autoComplete="off" className="mb-2 mr-sm-2" id="busquedaItem" onChange={(e) => this.localeventbarcode(e)} value={busqueda} />
                        </div>
                        <Alert variant="warning" >Ingrese codigo de barra</Alert>

                    </div>
                </Tab>
            </Tabs>
        )
    }
}

export default searchItem



// WEBPACK FOOTER //
// ./src/components/subcomponent/searchItem.jsx